import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-bid-item.reducer';

export const TenantBidItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantBidItemEntity = useAppSelector(state => state.tenantBidItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantBidItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantBidItem.detail.title">TenantBidItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.id}</dd>
          <dt>
            <span id="stockId">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.stockId">Stock Id</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.stockId}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.name">Name</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.name}</dd>
          <dt>
            <span id="qty">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.qty">Qty</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.qty}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.chargedMrp}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.discount}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.expDate}</dd>
          <dt>
            <span id="cgst">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.cgst">Cgst</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.cgst}</dd>
          <dt>
            <span id="sgst">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.sgst">Sgst</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.sgst}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantBidItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tenantBidItemEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantBidItem.bid">Bid</Translate>
          </dt>
          <dd>{tenantBidItemEntity.bid ? tenantBidItemEntity.bid.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantBidItem.tenantBids">Tenant Bids</Translate>
          </dt>
          <dd>{tenantBidItemEntity.tenantBids ? tenantBidItemEntity.tenantBids.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-bid-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-bid-item/${tenantBidItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantBidItemDetail;
